import { TextImageSection } from "./TextImageSection";
import { CardsSection } from "./CardsSection";
import { GallerySection } from "./GallerySection";
import { TestimonialsSection } from "./TestimonialsSection";
import { FaqSection } from "./FaqSection";

export const CUSTOM_RENDERERS = {
  text_image: TextImageSection,
  cards: CardsSection,
  gallery: GallerySection,
  testimonials: TestimonialsSection,
  faq: FaqSection,
};

export const renderSections = (sections, builtins, extraProps = {}) =>
  sections.map((s) => {
    const Comp = builtins[s.type] || CUSTOM_RENDERERS[s.type];
    return Comp ? <Comp key={s.id} id={s.id} content={s.content} {...extraProps} /> : null;
  });
